import React from 'react';
import { Container, WrapperContentCard } from './styles';
import { Variacoes } from '@/components/ranking/organisms/AreaVariationBest';
import { VariationSectionBest } from '@/global/components/AreaVariationBest/SectionCardVariationBest';

interface IProps {
  data: Variacoes;
}

export const VariationCardThree: React.FC<IProps> = ({ data}) => {
  return (
    <Container>
      <WrapperContentCard>
        <VariationSectionBest data={data} />
      </WrapperContentCard>
    </Container>
  );
};
